@import (reference) '../../../constants/spacing.module.less';
@import (reference) '../../../constants/screen-width-breakpoints.module.less';

.overlay-navigation-button {
  width: 48px;
  height: 48px;
  padding: @space-12;

  background: var(--light--button--background-color--1);
  border: 1px solid var(--default--button--border-color--1);

  box-shadow: 0 4px 2px -2px var(--dark--box-shadow-color--1);
  border-radius: 24px;

  position: absolute;
  top: 50%;
}

.previous-button {
  .overlay-navigation-button();
  left: @space-24;
}

.next-button {
  .overlay-navigation-button();
  right: @space-24;
}

@media @desktop {
  .previous-button {
    left: @space-16;
  }

  .next-button {
    right: @space-16;
  }
}
